import React, { useState } from 'react';
import { BrowserView, isMobile, MobileView } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { GoInfo } from '@react-icons/all-files/go/GoInfo';
import { StyledHeader, StyledHeaderMenuGroup } from './StyledTable';
import { Logo } from '../components/App/Header/Logo';
import { LittleLogo } from '../components/App/Header/LittleLogo';
import { LanguageSelector } from './LanguageSelector';
import { StyledInfoContainer, StyledLogoContainer } from '../components/App/Header/styled/StyledHeader';
import InfoModal from '../components/App/Header/InfoModal';
import { UserMenu } from '../components/App/Common/UserMenu';

const versionPackage = require('../../package.json');

export const StudiesHeader = () => {
  const config = useSelector((state) => state.config);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const hideInfo = config.APPLICATION_ASSETS?.info === 'hide';

  return (
    <StyledHeader>
      <div className={`StudyLobby_header ${isMobile && 'StudyLobby_header_mobile'}`}>
        <BrowserView>
          <StyledLogoContainer>
            <Logo />
            {!hideInfo && (
              <StyledInfoContainer>
                <GoInfo onClick={() => setShowInfoModal(!showInfoModal)} />
                <InfoModal show={showInfoModal} onClose={() => setShowInfoModal(!showInfoModal)} />
              </StyledInfoContainer>
            )}
          </StyledLogoContainer>
        </BrowserView>
        <BrowserView>
          <StyledHeaderMenuGroup>
            <LanguageSelector />
            <UserMenu />
          </StyledHeaderMenuGroup>
        </BrowserView>
        <MobileView>
          <LittleLogo />
        </MobileView>
        <MobileView>
          <p className="version">
            V.
            {versionPackage.version.replace('-', '.')}
          </p>
        </MobileView>
      </div>
    </StyledHeader>
  );
};

export default StudiesHeader;
